import React, { useId } from 'react'
import PropTypes from 'prop-types'

const RecurIcon = React.forwardRef(function RecurIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 4C11 3.44772 11.4477 3 12 3 14.3056 3 16.6029 3.87867 18.3671 5.64289 21.8776 9.15342 21.8776 14.8566 18.3671 18.3671 17.9766 18.7576 17.3434 18.7576 16.9529 18.3671 16.5624 17.9766 16.5624 17.3434 16.9529 16.9529 19.6824 14.2234 19.6824 9.78658 16.9529 7.05711 15.5771 5.68133 13.7944 5 12 5 11.4477 5 11 4.55228 11 4ZM7.04711 5.63292C7.43763 6.02344 7.43763 6.65661 7.04711 7.04713 4.31763 9.77661 4.31763 14.2134 7.04711 16.9429 8.42288 18.3187 10.2056 19 12 19 12.5523 19 13 19.4477 13 20 13 20.5523 12.5523 21 12 21 9.6944 21 7.39712 20.1214 5.63289 18.3571 2.12237 14.8466 2.12237 9.14344 5.63289 5.63292 6.02342 5.2424 6.65658 5.2424 7.04711 5.63292Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 6C2 5.44772 2.44772 5 3 5H8V10C8 10.5523 7.55228 11 7 11 6.44772 11 6 10.5523 6 10V7H3C2.44772 7 2 6.55228 2 6ZM17 13C17.5523 13 18 13.4477 18 14V17H21C21.5523 17 22 17.4477 22 18 22 18.5523 21.5523 19 21 19H16V14C16 13.4477 16.4477 13 17 13Z"
      ></path>
    </svg>
  )
})

RecurIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

RecurIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default RecurIcon
